export { default } from "./details-fields";
